import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Reveal";
import EpisodeCard from "@/components/EpisodeCard";
import VinylRecord from "@/components/VinylRecord";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { SHI_SHEET_URL } from "@/lib/images";

export default function EpisodesPage() {
  const [episodes, setEpisodes] = useState(null);

  useEffect(() => {
    api.get("/episodes").then((r) => setEpisodes(r.episodes)).catch(() => setEpisodes([]));
  }, []);

  return (
    <div data-testid="episodes-archive" className="pt-32 pb-28 md:pt-40">
      <Seo title="Episode Archive | That’s What SHi Said" description="Every episode of Let’s Elaborate and The Program, on record. Premieres Thursday, December 3, 2026." path="/episodes" />
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <Overline>The Archive</Overline>
          <h1 className="mt-4 font-display text-5xl font-black leading-[0.9] tracking-tight md:text-7xl">
            The Archive
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-latte md:text-lg">
            Let&rsquo;s Elaborate on Wednesdays. The Program on Saturdays. Everything lands
            here once it airs &mdash; every topic, every timestamp.
          </p>
        </Reveal>

        {episodes && episodes.length > 0 ? (
          <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {episodes.map((ep, i) => (
              <Reveal key={ep.slug} delay={0.06 * i}>
                <EpisodeCard episode={ep} />
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal delay={0.1}>
            <div
              data-testid="episodes-coming-soon"
              className="mt-16 flex flex-col items-start gap-10 rounded-3xl border border-corduroy bg-cocoa p-8 md:flex-row md:items-center md:p-14"
            >
              <VinylRecord size={180} label="TWSS" />
              <div>
                <h2 className="font-display text-3xl font-black leading-tight text-cream md:text-5xl">
                  The records aren&rsquo;t pressed yet.
                </h2>
                <p className="mt-5 max-w-xl text-base leading-relaxed text-latte md:text-lg">
                  Program 001 premieres Thursday, December 3, 2026. After that, this page becomes the archive: every episode, every topic, every timestamp. Get The Shi Sheet and you&rsquo;ll know first.
                </p>
                <a
                  href={SHI_SHEET_URL}
                  target="_blank"
                  rel="noopener"
                  data-testid="archive-notify-button"
                  className="mt-8 inline-block rounded-full bg-ember px-8 py-4 font-bold text-ink transition-colors hover:bg-neon hover:text-cream"
                >
                  Get The Shi Sheet
                </a>
              </div>
            </div>
          </Reveal>
        )}
      </div>
    </div>
  );
}
